export const SubscriptionStatus = {
  SUBSCRIBED: "SUBSCRIBED",
  TRIAL: "TRIAL",
  NOT_SUBSCRIBED: "NOT_SUBSCRIBED",
  BLOCKED: "BLOCKED"
};



// WEBPACK FOOTER //
// ./src/utils/helpers/SubscriptionStatus.js